import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import HomeIcon from "@mui/icons-material/Home";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import DescriptionIcon from "@mui/icons-material/Description";
import PersonIcon from "@mui/icons-material/Person";

import CustomForm from "../../../helper-components/form/CustomForm";
import NavigationFooter from "../../../helper-components/misc/NavigationFooter";

import CookiesTable from "./components/CookiesTable";

import { getLanguage } from "../../../config/language/language.js";

/**
 * The cookies page.
 */
export default function Cookies(props) {
    return (
        <Container maxWidth="xl" sx={{ mt: 2, mb: 2 }}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <CustomForm title={getLanguage().COOKIES_TITLE} subtitle={getLanguage().COOKIES_SUBTITLE} icon={<PersonIcon />} />
                </Grid>

                <Grid item xs={12}>
                    <CookiesTable {...props} />
                </Grid>

                <NavigationFooter
                    rows={2}
                    options={[
                        {
                            path: `/database/resources`,
                            title: "Resources",
                            variant: "outlined",
                            icon: <DescriptionIcon />
                        },
                        {
                            path: `/database/transcripts`,
                            title: "Transcripts",
                            variant: "outlined",
                            icon: <TextFieldsIcon />
                        },
                        {
                            path: `/home`,
                            title: "Home",
                            variant: "outlined",
                            icon: <HomeIcon />
                        }
                    ]}
                />
            </Grid>
        </Container>
    );
}
